import { render, staticRenderFns } from "./TicketMessageLikeButton.vue?vue&type=template&id=cf65125e&scoped=true&"
import script from "./TicketMessageLikeButton.vue?vue&type=script&lang=ts&"
export * from "./TicketMessageLikeButton.vue?vue&type=script&lang=ts&"
import style0 from "./TicketMessageLikeButton.vue?vue&type=style&index=0&id=cf65125e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf65125e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf65125e')) {
      api.createRecord('cf65125e', component.options)
    } else {
      api.reload('cf65125e', component.options)
    }
    module.hot.accept("./TicketMessageLikeButton.vue?vue&type=template&id=cf65125e&scoped=true&", function () {
      api.rerender('cf65125e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketMessageLikeButton.vue"
export default component.exports